import {useMutation} from "@tanstack/react-query";

import {ForgotRequest} from "@/src/modules/auth/types";
import {errorHandler} from "@/src/modules/core/lib";

import {authService} from "../services";

export default function useForgot() {
  return useMutation({
    mutationFn: (data: ForgotRequest) => authService.forgot(data),
    retry: false,
    onError: errorHandler,
  });
}
